import React from 'react';
import { Link } from 'react-router-dom';
import './WellwiredTokens.css';
import './Wellwired.css';
import './WellwiredReview.css';

const versions = [
  {
    label: 'A',
    title: 'Air quality first.',
    subtitle: 'Hardwired by design.',
    description: 'The original research draft for a broad healthy-home audience. Air quality leads; low-RF connectivity is clear from the first screen.',
    path: '/wellwired-a',
    action: 'Explore version A',
  },
  {
    label: 'B',
    title: 'Low-RF technology.',
    subtitle: 'Air quality built in.',
    description: 'The preferred direction, now giving hardwired leak detection and automatic shutoff early prominence alongside Air and Electrical.',
    path: '/wellwired-b',
    action: 'Explore version B',
    recommended: true,
  },
];

export default function WellwiredReview() {
  return (
    <div className="wellwired ww-review">
      <a className="ww-skip" href="#ww-review-main">Skip to content</a>
      <header className="ww-review-header ww-wrap">
        <Link to="/wellwired-review" className="ww-lockup" aria-label="Wellwired design review home">
          <span className="ww-wordmark">Wellwired</span><span className="ww-endorsement">by BAi</span>
        </Link>
        <span>Design review · October 2026</span>
      </header>
      <main id="ww-review-main">
        <section className="ww-review-intro ww-wrap">
          <p className="ww-kicker">Research into a clearer first impression</p>
          <h1>The same quiet feeling.<br /><span>A much clearer story.</span></h1>
          <p>The new design puts indoor air quality and low-RF technology up front, makes the work tangible, and keeps the warmth of Wellwired.</p>
          <p className="ww-review-context">Version B is the preferred direction, with stronger water protection alongside Air and Electrical. Version A remains available for comparison.</p>
        </section>
        <section className="ww-review-versions ww-wrap" aria-label="Compare the two new versions">
          {versions.map(version => (
            <article className={`ww-review-version${version.recommended ? ' ww-review-recommended' : ''}`} key={version.label}>
              <div className="ww-review-version-label"><span className="ww-index">{version.label}</span><span>{version.recommended ? 'Preferred · Air, Electrical and Water' : 'Original draft · air quality first'}</span></div>
              <h2>{version.title}<br /><span>{version.subtitle}</span></h2>
              <p>{version.description}</p>
              <Link className="ww-action" to={version.path}>{version.action}<span aria-hidden="true">↗</span></Link>
            </article>
          ))}
        </section>
        <section className="ww-review-baseline ww-wrap">
          <div><p className="ww-kicker">The starting point</p><h2>The current page is here, too.</h2><p>Keep it beside the drafts to compare clarity, pacing and how quickly the offering becomes understandable.</p></div>
          <Link className="ww-text-link" to="/wellwired">Open the original page <span aria-hidden="true">↗</span></Link>
        </section>
        <section className="ww-review-notes ww-wrap">
          <div><p className="ww-kicker">What changed</p><h2>More substance,<br />earlier in the page.</h2></div>
          <ul>
            <li>Indoor air quality and low-RF design appear in the opening.</li>
            <li>Version B gives Air, Electrical and Water early prominence, with hardwired sensing and automatic shutoff.</li>
            <li>The day explorer uses deliberate choices and ordinary scrolling.</li>
            <li>Design, Build and optional Verify have clearer roles and separate prices.</li>
            <li>Low-EMF scope and building-biologist collaboration are addressed directly.</li>
          </ul>
        </section>
        <section className="ww-review-questions ww-wrap">
          <p className="ww-kicker">A useful way to review</p>
          <h2>Give the opening ten seconds.</h2>
          <ol><li>What does Wellwired do?</li><li>Which priorities did you notice first?</li><li>What would you need to know before starting a conversation?</li></ol>
          <p>These are review drafts, with the existing concept imagery and quote-defined Verify scope. No project measurements or customer outcomes have been invented.</p>
        </section>
      </main>
      <footer className="ww-review-footer ww-wrap"><span>Wellwired by BAi · New construction</span><Link to="/">BAi Systems <span aria-hidden="true">↗</span></Link></footer>
    </div>
  );
}
